import React from 'react';
import { Roadmap } from '../components/roadmap';

export const RoadmapPage: React.FC = () => {
  return <Roadmap />;
};
